import { Alert, Button, Flex, Form, Input } from "antd";
import { ApiService } from "api/api.service";
import React, { useEffect, useState } from "react";
import { getErrorMessage } from "utils/functions";

const OTPForm = ({
  phoneDetails,
}: {
  phoneDetails: {
    phone?: string;
    code?: string;
  } | null;
}) => {
  const resendOtp = ApiService.user.useResendOTP();
  const phoneVerify = ApiService.user.usePhoneLoginVerify();
  const [otpForm] = Form.useForm();

  const [resendDisabled, setResendDisabled] = useState(true);
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (resendDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            setResendDisabled(false);
            if (interval) clearInterval(interval);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
      setResendDisabled(true);
      setTimer(60);
    };
  }, [resendDisabled]);

  function handleOTPVerification(values: { otp: string }) {
    if (!phoneDetails) return;
    phoneVerify.mutate({
      phone: phoneDetails.phone!,
      code: phoneDetails.code!,
      otp: values.otp,
    });
  }

  function handleResendOTP() {
    if (!phoneDetails) return;

    resendOtp.mutate(
      {
        phone: phoneDetails.phone,
        code: phoneDetails.code,
      },
      {
        onSuccess: () => {
          otpForm.resetFields();
          setResendDisabled(true);
          setTimer(60);
        },
      },
    );
  }
  return (
    <Form form={otpForm} layout="vertical" onFinish={handleOTPVerification}>
      <Flex justify="space-between" align="center">
        <span>OTP</span>
        <Button type="link" disabled={resendDisabled} onClick={handleResendOTP} loading={resendOtp.isPending}>
          {resendDisabled ? `Resend OTP in ${timer}s` : "Resend OTP"}
        </Button>
      </Flex>
      <Form.Item name="otp" rules={[{ required: true, message: "Enter code", pattern: /^\d{6}$/ }]}>
        <Input.OTP style={{ width: "100%" }} length={6} />
      </Form.Item>

      {phoneVerify.isError && (
        <Alert closable type="error" style={{ marginBottom: 24 }} message={getErrorMessage(phoneVerify.error)} />
      )}

      {resendOtp.isError && (
        <Alert closable type="error" style={{ marginBottom: 24 }} message={getErrorMessage(resendOtp.error)} />
      )}

      <Button block loading={phoneVerify.isPending} type="primary" htmlType="submit">
        Login
      </Button>
    </Form>
  );
};

export default OTPForm;
